import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';

export const usePaceAheadEnabled = () => useConfigMatch({ [FEATURE_FLAGS.PACE_AHEAD_ENABLED]: 'true' });
